import i18n from '@/i18n'

const ROLE_HIERARCHY = {
  ROLE_SUPER_ADMIN: 100,
  ROLE_ADMIN: 80,
  ROLE_MODERATOR: 60,
  ROLE_USER: 40,
  ROLE_GUEST: 20
}

export function getUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}')
  } catch {
    return {}
  }
}

export function getRoles() {
  try {
    return JSON.parse(localStorage.getItem('roles') || '[]')
  } catch {
    return []
  }
}

export function getPermissions() {
  try {
    return JSON.parse(localStorage.getItem('permissions') || '[]')
  } catch {
    return []
  }
}

export function hasRole(role) {
  const userRoles = getRoles()
  return userRoles.some(r => {
    if (role === r) return true
    const userLevel = ROLE_HIERARCHY[r]
    const requiredLevel = ROLE_HIERARCHY[role]
    if (userLevel && requiredLevel) return userLevel >= requiredLevel
    return false
  })
}

export function hasAnyRole(roles) {
  return roles.some(hasRole)
}

export function hasPermission(permission) {
  return getPermissions().includes(permission)
}

export function hasAnyPermission(permissions) {
  return permissions.some(hasPermission)
}

export function roleLabel(role) {
  const key = {
    ROLE_SUPER_ADMIN: 'permission.SUPER_ADMIN',
    ROLE_ADMIN: 'permission.ADMIN',
    ROLE_MODERATOR: 'permission.MODERATOR',
    ROLE_USER: 'permission.USER'
  }[role]
  return key ? i18n.t(key) : role
}

export function roleLabels() {
  const roles = getRoles()
  if (roles.length === 0) return i18n.t('permission.unknown')
  return roles.map(r => roleLabel(r)).join(' / ')
}
